module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-it-IT.5cbb13ea.jpg";